<template>
    <div>
        <Button type="primary" @click="selectImgModal=true">选择图片</Button>
        <!-- 选择图片 start -->
        <Modal
                @on-visible-change="visibleChange"
                class="dosion-image"
                v-model="selectImgModal"
                title="选择图片"
                :loading="true"
                width="1100"
                :closable="false"
                height="600" footer-hide>
            <!-- 选择图片 end -->
            <Row>
                <Col span="6">
                    <Card style="width:273px;height: 600px;overflow: auto;" shadow>
                        <p slot="title">
                            图片分类
                        </p>
                        <Button @click="addFolder(null)" slot="extra" icon="md-add" type="primary" shape="circle">新增
                        </Button>
                        <el-tree :data="folderList" :props="defaultProps" default-expand-all highlight-current
                                 :expand-on-click-node="false" @node-click="treeClick">
                               <span class="folder-tree-node" slot-scope="{ node, data }">
                                <span>{{ node.label }}</span>
                                <span v-if="data.id!=0">
                                  <el-button
                                          type="text"
                                          size="mini"
                                          icon="el-icon-edit"
                                          @click.stop="addFolder(data)">
                                  </el-button>
                                  <el-button
                                          type="text"
                                          size="mini"
                                          icon="el-icon-delete"
                                          @click.stop="delFolder(data)">
                                  </el-button>
                                </span>
                               </span>
                        </el-tree>
                    </Card>
                </Col>
                <Col span="18">
                    <Card style="width:825px;height: 600px;" shadow>

                        <Spin size="large" fix v-if="loading">
                            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                            加载中...
                        </Spin>
                        <p slot="title">
                            {{typeTitle}}
                            <!-- <el-checkbox v-model="isSelectAll" @change="selectAll" style="margin-left: 20px">全选
                             </el-checkbox>-->
                        </p>
                        <a slot="extra">
                            <div v-if="selectImageList!=null&&selectImageList.length>0">
                                <Button type="text" @click="clearSelect">取消选择</Button>
                                <Button icon="md-trash" type="error" shape="circle" @click="batchDelete">删除图片</Button>
                            </div>
                            <div v-else>
                                <Input v-model="query.original" type="text" suffix="ios-search" search
                                       @on-search="getFile"
                                       placeholder="请输入名称搜索" style="width: auto;margin-right: 10px"/>
                                <el-upload
                                        :action="uploadUrl()"
                                        :show-file-list="false"
                                        :data="uploadData"
                                        :before-upload="beforeUpload"
                                        :on-error="errorUpload"
                                        :headers="uploadHeader"
                                        accept="image/*"
                                        multiple
                                        :on-success="handleAvatarSuccess" style="display: inline;">
                                    <Button icon="ios-cloud-upload-outline" type="primary" shape="circle">上传图片</Button>
                                </el-upload>
                            </div>
                        </a>
                        <div style="height: 510px;overflow: auto">
                            <el-checkbox-group v-model="selectImageList">
                                <el-card v-for="(item,index) in fileList" :key="item.id"
                                         class="imgCard"
                                         style="width:120px;border: 0px;border-radius: 0px;position: relative"
                                         :body-style="{ padding: '0px' }">
                                    <el-checkbox :label="item.id" style="position: absolute;left: 3px;top: 0px">&nbsp;
                                    </el-checkbox>

                                    <el-image
                                            style="width: 120px; height: 120px"
                                            :src="item.url"
                                            :preview-src-list="[item.original]">
                                    </el-image>

                                    <!--<viewer>
                                        <img style="width: 120px; height: 120px"
                                             :data-source="item.original"
                                             :src="item.url">
                                    </viewer>-->
                                    <div>
                                        <!--@focus="focusName(item)"
                                        @blur="blurName(item)"-->
                                        <el-input :title="item.name" v-model="item.name" autofocus
                                                  placeholder="请输入内容"></el-input>
                                    </div>
                                </el-card>
                            </el-checkbox-group>
                            <div style="clear: both"></div>
                        </div>
                    </Card>
                </Col>
            </Row>
            <Page style="float: left;margin-top: 5px;margin-left: 10px" v-if="count>0" transfer @on-change="pageChange"
                  @on-page-size-change="sizeChange"
                  :page-size="18"
                  :page-size-opts="[18,36,72,144]"
                  prev-text="上一页"
                  next-text="下一页" :total="count" show-elevator show-total show-sizer/>
            <Button @click="close" type="primary" style="float: right;margin: 10px">关闭</Button>
            <Button v-if="!hiedOk" @click="okSelect" type="primary" style="float: right;margin: 10px">确定</Button>

            <p v-if="selectImageList!=null&&selectImageList.length>0"
               style="float: right;margin: 10px;line-height: 30px">
                已选择
                <span style="color: #ed4014">{{selectImageList.length}}</span> 张图片</p>
            <div style="clear: both"></div>
        </Modal>
    </div>
</template>
<style>
    .dosion-image .ivu-modal-body {
        padding: 0px !important;
    }

    .dosion-image .ivu-card-extra {
        top: 8px;
    }

    .dosion-image .imgCard {
        float: left;
        margin: 5px;
        margin-bottom: 10px;
    }

    .dosion-image .imgCard.el-card.is-always-shadow, .el-card.is-hover-shadow:focus, .el-card.is-hover-shadow:hover {
        -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0);
    }

    .folder-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .imgCard .el-input__inner {
        border: 1px solid transparent;
        border-radius: 0px;
        padding: 0px;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        vertical-align: top;
        font-style: normal;
    }

    .imgCard.el-input__inner:hover {
        border-color: transparent;
    }

    .imgCard .el-input__inner:focus {
        border: 1px solid #409EFF;
        outline: 0;
    }
</style>
<script>
    import {addFolder, delFolder, folderList, updateFolder} from '@/api/system/folder'
    import {batchDeleteFile, fetchList} from '@/api/system/file'
    import dataUtils from '@/utils/dataUtils';
    import appUtils from '@/utils/appUtils';
    import Setting from '@/setting';

    export default {
        name: 'dosion-image',
        props: {
            value: {
                type: Boolean
            },
            hiedOk: {
                type: Boolean
            }
        },
        data() {
            return {
                loading: false,//加载中
                site: {},//站点信息
                typeTitle: '全部分类',//分类标题
                folderList: [],//文件夹列表
                selectForder: {},//选择的文件夹
                defaultProps: {
                    children: 'children',
                    label: 'name'
                },
                fileList: [],//文件列表
                uploadData: {
                    'fileType': '0'
                },
                uploadHeader: {
                    Authorization: 'Bearer ' + dataUtils.getData(Setting.key.token)
                },
                viewer: null,//图片预览
                selectImageList: [],//选中的图片
                isSelectAll: false,//是否全选
                tempName: null,//临时名称
                query: {
                    'folderId': null,
                    'original': null,
                    'type': 'IMAGE',
                    'thumbnail': false,
                    current: 1, // 当前页数
                    size: 18 // 每页显示多少条
                },
                maxLength: 18,//显示个数
                selectImgModal: false,
                count: 0

            }
        },
        watch: {
            selectImageList() {
                if (this.selectImageList == null || this.selectImageList.length <= 0) {
                    this.isSelectAll = false
                    return
                }
                if (this.selectImageList.length == this.fileList.length) {
                    this.isSelectAll = true
                } else {
                    this.isSelectAll = false
                }
            },
            selectImgModal(val) {
                if (val) {
                    this.selectImageList = []
                    this.getFolder()
                }
            },
            value(val) {
                if (val) {
                    if (val) {
                        this.selectImgModal = true
                    }
                }
            },

            deep: true
        },
        methods: {
            visibleChange(val) {
                this.$emit('input', val)
            },
            uploadUrl() {
                return Setting.apiBaseURL + '/system/file/upload?folderId=' + this.selectForder.id
            },
            //加载文件夹
            getFolder() {
                this.loading = true
                folderList({'type': '0'}).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.folderList = [{
                            id: 0,
                            name: '全部分类',
                            children: res.data
                        }]
                        this.selectForder = this.folderList[0]
                        this.getFile()
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //获取文件
            getFile() {
                this.loading = true
                this.query.folderId = this.selectForder.id == 0 ? null : this.selectForder.id

                fetchList(this.query).then(res => {
                    this.loading = false
                    if (res.state) {
                        this.fileList = res.data.records
                        this.count = res.data.total
                    } else {
                        appUtils.showError(res.msg)
                    }
                })
            },
            //添加文件夹
            addFolder(folder) {
                var folderModel = {
                    'type': '0',
                    'name': null
                }
                if (folder != null) {
                    var model = JSON.parse(JSON.stringify(folder))
                    folderModel.id = model.id
                    folderModel.name = model.name
                }
                this.$Modal.confirm({
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: folderModel.name,
                                autofocus: true,
                                placeholder: '请输入文件夹名称'
                            },
                            on: {
                                input: (val) => {
                                    folderModel.name = val
                                }
                            }
                        })
                    },
                    loading: true,
                    onOk: () => {
                        if (folderModel.id == null) {
                            addFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        } else {
                            updateFolder(folderModel).then(res => {
                                if (res.state) {
                                    this.getFolder()
                                    appUtils.showSuccess(res.msg)
                                } else {
                                    appUtils.showError(res.msg)
                                }
                                this.$Modal.remove()
                            })
                        }


                    }
                })
            },
            //删除文件夹
            delFolder(folder) {
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确定删除文件夹？</p><p style="color: red">（删除后该分类图片自动移动到全部分类下）</p>',
                    loading: true,
                    onOk: () => {
                        delFolder(folder.id).then(res => {
                            if (res.state) {
                                this.getFolder()
                                appUtils.showSuccess(res.msg)
                                this.selectImageList = []
                            } else {
                                appUtils.showError(res.msg)
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //上传之前
            beforeUpload(file) {
                this.loading = true
            },
            //上传失败
            errorUpload(err, file, fileList) {
                appUtils.showError(err)
                this.loading = false
            },
            //上传成功
            handleAvatarSuccess(res, file) {
                if (res.state) {
                    appUtils.showSuccess('上传成功！')
                    this.getFile()
                } else {
                    if (res.code == 1001) {
                        dataUtils.removeAllData()
                        location.reload()
                    } else {
                        appUtils.showError(res.msg)
                    }
                }
            },
            //树节点点击
            treeClick(data, node, el) {
                if (this.selectForder.id != data.id) {
                    this.selectForder = data
                    this.typeTitle = data.name
                    this.getFile()
                    this.selectImageList = []
                }
            },
            //取消图片选择
            clearSelect() {
                this.selectImageList = []
            },
            //批量删除
            batchDelete() {
                this.$Modal.confirm({
                    title: '提示',
                    content: '确定删除选择的图片？',
                    loading: true,
                    onOk: () => {
                        if (this.selectImageList == null || this.selectImageList.length <= 0) {
                            appUtils.showError('请选择要删除的图片！')
                            return
                        }
                        batchDeleteFile(this.selectImageList.toString()).then(res => {
                            if (res.state) {
                                appUtils.showSuccess('删除图片成功！')
                                this.getFile()
                                this.selectImageList = []
                            } else {
                                appUtils.showError('删除图片失败！')
                            }
                            this.$Modal.remove()
                        })
                    }
                })
            },
            //确认选择
            okSelect() {
                var selectImg = []
                dataUtils.each(this.selectImageList, (k, o) => {
                    var arr = this.fileList.filter(t => t.id == o)
                    if (arr != null && arr.length > 0) {
                        selectImg.push(arr[0])
                    }
                })
                this.$emit('select', selectImg)
                this.selectImageList = []
                this.selectImgModal = false
            },
            //确认选择
            close() {
                this.selectImgModal = false
            },
            //全选
            selectAll(val) {
                this.selectImageList = []
                dataUtils.each(this.fileList, (key, obj) => {
                    this.selectImageList.push(obj.id)
                })
            },
            // 页数发生改变
            pageChange(val) {
                this.query.current = val
                this.getFile()
            },
            // 每页显示条数发生改变
            sizeChange(val) {
                this.query.size = val
                this.query.current = 1
                this.getFile()
            }
        },
        mounted() {

        }
    }
</script>
